/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import { Button } from "__barrel_optimize__?names=Button!=!@mui/material";
import { BillingAddressElement, PaymentElement, useCheckout } from '@stripe/react-stripe-js/checkout';
import React from 'react';
import toast from 'react-hot-toast';
function CheckoutForm() {
    var _order_stripe_product, _order_stripe_product1, _order_stripe_product2, _order_stripe_product_default_price, _order_stripe_product3, _order_stripe_product_default_price1, _order_stripe_product4;
    const { order } = useNewOrder();
    const checkoutState = useCheckout();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (checkoutState.type === 'loading') {
            toast.loading('Processing payment, please wait...');
        } else if (checkoutState.type === 'error') {
            toast.error("Payment failed: ".concat(checkoutState.error.message));
        } else if (checkoutState.type === 'success') {
            const result = await checkoutState.checkout.confirm();
            if (result.type === 'error') {
                toast.error("Payment failed: ".concat(result.error.message));
            }
        }
    };
    return /*#__PURE__*/ _jsx("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 md:grid-cols-3 gap-10",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "md:col-span-2 md:order-1 order-2",
                    children: [
                        /*#__PURE__*/ _jsx(BillingAddressElement, {}),
                        /*#__PURE__*/ _jsx(PaymentElement, {
                            options: {
                                layout: 'tabs'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "md:col-span-1 md:order-2 order-1",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "text-lg",
                                children: "Order Summary"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-5 mt-5",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-start gap-5 border-b pb-5 border-neutral-300",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: (_order_stripe_product = order.stripe_product) === null || _order_stripe_product === void 0 ? void 0 : _order_stripe_product.images[0],
                                                alt: (_order_stripe_product1 = order.stripe_product) === null || _order_stripe_product1 === void 0 ? void 0 : _order_stripe_product1.name,
                                                className: "h-16 w-16 object-contain"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: (_order_stripe_product2 = order.stripe_product) === null || _order_stripe_product2 === void 0 ? void 0 : _order_stripe_product2.name
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: (order === null || order === void 0 ? void 0 : (_order_stripe_product3 = order.stripe_product) === null || _order_stripe_product3 === void 0 ? void 0 : (_order_stripe_product_default_price = _order_stripe_product3.default_price) === null || _order_stripe_product_default_price === void 0 ? void 0 : _order_stripe_product_default_price.unit_amount) ? "$".concat((order.stripe_product.default_price.unit_amount / 100).toFixed(2)) : 'Price not available'
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                order.add_ons && order.add_ons.length > 0 && order.add_ons.map((addon, index)=>{
                                    var _addon_default_price;
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-start gap-5 border-b pb-5 border-neutral-300",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: addon.images[0],
                                                    alt: addon.name,
                                                    className: "h-16 w-16 object-contain"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col gap-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: addon.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            children: ((_addon_default_price = addon.default_price) === null || _addon_default_price === void 0 ? void 0 : _addon_default_price.unit_amount) ? "$".concat((addon.default_price.unit_amount / 100).toFixed(2)) : 'Price not available'
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-5 flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-lg",
                                        children: "Total: "
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "text-xl font-semibold",
                                        children: "$".concat(((((_order_stripe_product4 = order.stripe_product) === null || _order_stripe_product4 === void 0 ? void 0 : (_order_stripe_product_default_price1 = _order_stripe_product4.default_price) === null || _order_stripe_product_default_price1 === void 0 ? void 0 : _order_stripe_product_default_price1.unit_amount) || 0) + (order.add_ons ? order.add_ons.reduce((total, addon)=>{
                                            var _addon_default_price;
                                            return total + (((_addon_default_price = addon.default_price) === null || _addon_default_price === void 0 ? void 0 : _addon_default_price.unit_amount) || 0);
                                        }, 0) : 0)) / 100)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-5 flex flex-row items-center justify-end",
                            children: /*#__PURE__*/ _jsx(Button, {
                                size: "large",
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                fullWidth: true,
                                children: "Place Order"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
export default CheckoutForm;
